<template>
  <div class="admins-page">
    <app-page-header title="Admins">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus" />NOVO
      </button>
    </app-page-header>

    <admins-table></admins-table>
  </div>
</template>

<script>
import AdminsTable from '@/components/Tables/AdminsTable.vue';

export default {
  name: 'admins-page',
  components: {
    AdminsTable,
  },
  methods: {
    create() {
      this.$router.push('/admins/create');
    },
  },
};
</script>

<style lang="scss" scoped></style>
